import { render, staticRenderFns } from "./DealMultipleCandidates.vue?vue&type=template&id=4f701bb7"
import script from "./DealMultipleCandidates.vue?vue&type=script&lang=js"
export * from "./DealMultipleCandidates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports